// Banco Oficial y Baterías de Evaluación Psicométrica y Psicológica UNINAV 2026
// Adaptado a los lineamientos del proceso de selección de la Universidad Naval (SEMAR)
// y del Centro Nacional de Evaluación para la Educación Superior (CENEVAL).

export { PSICOMETRICO_QUESTIONS } from './uninavData/psychometricQuestions';
export {
  PERSONALITY_INVENTORY,
  PERSONALITY_OPTIONS,
  CONSISTENCY_PAIRS
} from './uninavData/personalityInventory';
export { MOSS_SITUATIONAL_QUESTIONS } from './uninavData/mossSituationalQuestions';
export {
  calculatePsychometricEvaluation,
  calculatePersonalityEvaluation,
  calculateMossEvaluation,
  generateComprehensiveVerdict
} from './uninavData/uninavScoring';

// Alias para compatibilidad con implementaciones previas
import { PERSONALITY_INVENTORY } from './uninavData/personalityInventory';
export const PSICOLOGICO_QUESTIONS = PERSONALITY_INVENTORY;

export const UNINAV_MODULE_INFO = {
  title: "Batería Integral de Admisión UNINAV 2026",
  subtitle: "Evaluación Psicométrica, Perfil Clínico/Personalidad y Liderazgo Situacional MOSS",
  description: "En el proceso real de la Universidad Naval y SEMAR, los aspirantes presentan entre 200 y 500 reactivos distribuidos en 3 baterías clave. Se evalúa con rigurosidad la congruencia y veracidad para descartar manipulación o fingimiento.",
  phases: [
    {
      phase: "Fase 1: Académica (CENEVAL)",
      description: "Examen EXANI-II de 168 reactivos (Pensamiento Matemático, Comprensión Lectora, Redacción Indirecta y Módulos Disciplinares).",
      venue: "Sedes Foráneas y Nacionales"
    },
    {
      phase: "Fase 2: Definitiva (Naval)",
      description: "Pruebas de capacidad física, examen médico de gabinete, valoración psicométrica de CI y evaluación psicológica presencial.",
      venue: "Heroica Escuela Naval Militar (Antón Lizardo, Ver.)"
    }
  ],
  batteries: [
    {
      id: "bateria_personalidad",
      title: "1. Personalidad y Perfil Clínico (Tipo MMPI / 16PF)",
      count: "180 reactivos con Escalas de Sinceridad (L) y 17 Pares de Consistencia",
      objective: "Evaluar madurez, control de impulsos, apego a la disciplina y descartar falseamiento de respuestas.",
      format: "Verdadero (V) / Falso (F)"
    },
    {
      id: "bateria_psicometrica",
      title: "2. Razonamiento e Inteligencia (Tipo Raven / Beta-III / Bennett)",
      count: "100 reactivos cronometrados (60 minutos)",
      objective: "Medir CI Naval Estimado, resolución abstracta, mecánica de poleas/engranes, orientación espacial 3D y cálculo naval.",
      format: "Opción Múltiple (A, B, C)"
    },
    {
      id: "bateria_moss",
      title: "3. Comportamiento y Liderazgo (Test MOSS Situacional)",
      count: "30 escenarios tácticos de toma de decisiones",
      objective: "Evaluar capacidad de mando, respeto a la jerarquía, relaciones interpersonales y ética militar bajo zafarrancho.",
      format: "Escenario Situacional de 4 Opciones"
    }
  ]
};

export const LIKERT_OPTIONS = [
  { value: "V", label: "Verdadero", color: "#34d399", sublabel: "Describe mi conducta o forma de pensar habitual" },
  { value: "F", label: "Falso", color: "#f87171", sublabel: "No coincide con mi comportamiento o actitud real" }
];

export const CONSEJOS_ENTREVISTA_UNINAV = [
  {
    title: "1. Postura y Lenguaje Corporal en Antón Lizardo",
    tip: "Mantén la espalda erguida, manos apoyadas sobre los muslos, vista directa a los ojos del oficial psicólogo sin desafiar, y tono de voz firme y claro. La firmeza física transmite estabilidad emocional inmediata."
  },
  {
    title: "2. Coherencia Absoluta con tus Escalas de Sinceridad",
    tip: "El psicólogo tendrá impreso tu reporte psicométrico con las banderas de consistencia y la Escala L. Si marcaste 'Nunca he sentido enojo', te preguntará directamente: '¿Así que jamás te has molestado en 18 años?'. Responde con madurez y honestidad: 'Como todo ser humano me he enojado, señor, pero poseo el autocontrol para no perder la compostura ni faltar al respeto'."
  },
  {
    title: "3. Por qué 'falsear' es la causa #1 de 'No Apto'",
    tip: "En SEMAR se busca confiabilidad y lealtad. Quien intenta manipular las pruebas para parecer 'el cadete perfecto' es inmediatamente catalogado como no confiable e inconsistente. Es preferible admitir una debilidad humana superada que proyectar una perfección fingida."
  },
  {
    title: "4. Motivación Vocacional Genuina",
    tip: "Evita respuestas cliché como 'porque se ven bonitos los uniformes' o 'porque pagan bien'. Fundamenta tu interés en el honor, la disciplina, la superación técnica/académica y la vocación de servicio a la soberanía marítima de México."
  },
  {
    title: "5. Manejo de Preguntas de Presión (Estrés Inducido)",
    tip: "Es común que el entrevistador simule desinterés, hable con tono severo o critique tu promedio escolar. Es una prueba deliberada de tolerancia al estrés. Nunca bajes la cabeza ni te muestres a la defensiva; mantén la compostura y responde con respeto militar: 'Entendido, considero que...'"
  }
];
